/**
 *
 * Function for The Slide Show in Research Area in Front Page (JS)
 *
 * @author Yusuke Manabe @ Space-Time Inc.
 * @version 2020-10-09
 *
 *
 */


(function() {
	const breakpoint   = 1300;
	const nextInterval = 7000;

	const slideShowElement      = document.getElementsByClassName('slide-show')[0];
	const slideShowInnerElement = slideShowElement.getElementsByClassName('slide-show-inner')[0];
	const itemElements          = Array.prototype.slice.call(slideShowElement.getElementsByClassName('part-research-slide-show-item'));
	const prevElement           = slideShowElement.getElementsByClassName('slide-show-prev')[0];
	const nextElement           = slideShowElement.getElementsByClassName('slide-show-next')[0];

	const options = {
		root      : null,
		rootMargin: '-50% 0px',
		threshold : 0
	};

	const observer = new IntersectionObserver(setClickTime, options);

	let currentNum = 0;
	let resizeTime;
	let clickTime;

	// -------------------------------------------------------------------------


	if (window.innerWidth > breakpoint) currentNum = 1;
	setCurrentSlide();
	setSlidePosition();
	observer.observe(prevElement);
	if (window.ontouchstart !== undefined) initFlick();


	setTimeout(function() {
		slideShowInnerElement.style.opacity            = 1;
		slideShowInnerElement.style.transitionDuration = '0.1s';
	}, 10);
	setTimeout(function() {
		slideShowInnerElement.style.transitionDuration = '1s';
		prevElement.style.transitionDuration           = '0.2s';
		nextElement.style.transitionDuration           = '0.2s';
	}, 500);


	window.addEventListener('resize', function() {
		clearTimeout(resizeTime);
		resizeTime = setTimeout(setSlidePosition, 16);
	}, false);

	prevElement.addEventListener('click', function() {
		prevClickEvent();
	}, false);

	nextElement.addEventListener('click', function() {
		nextClickEvent();
	}, false);

//------------------------------------------------------------------------------

	function setClickTime(element) {
		clearTimeout(clickTime);
		clickTime = setTimeout(nextClickEvent, nextInterval);
	}

	function prevClickEvent() {
		clearTimeout(clickTime);
		if (! prevElement.classList.contains('disabled')) {
			currentNum = currentNum - 1;
			setCurrentSlide();
			setSlidePosition();
		}
		clickTime = setTimeout(nextClickEvent, nextInterval);
	}

	function nextClickEvent() {
		clearTimeout(clickTime);
		if (! nextElement.classList.contains('disabled')) {
			currentNum = currentNum + 1;
			setCurrentSlide();
			setSlidePosition();
		}
		clickTime = setTimeout(nextClickEvent, nextInterval);
	}


//------------------------------------------------------------------------------

	function setCurrentSlide() {
		itemElements.forEach(element => {
			element.classList.remove('current');
			element.classList.remove('prev');
			element.classList.remove('next');
		});
		itemElements[currentNum].classList.add('current');
		if (itemElements[currentNum - 1] != undefined) {
			itemElements[currentNum - 1].classList.add('prev');
		}
		if (itemElements[currentNum + 1] != undefined) {
			itemElements[currentNum + 1].classList.add('next');
		}
	}

	function setSlidePosition() {
		const slideShowWidth       = slideShowElement.getBoundingClientRect().width;
		let rangeFromCentralToEdge = 0;
		for (let i = 0; i < itemElements.length; i++) {
			const element = itemElements[i];
			if (element.classList.contains('current')) {
				rangeFromCentralToEdge += element.getBoundingClientRect().width / 2;
				break;
			} else {
				rangeFromCentralToEdge += element.getBoundingClientRect().width;
			}
		}
		slideShowInnerElement.style.marginLeft = (slideShowWidth / 2) - rangeFromCentralToEdge + 'px';

		let prevNum = 0;
		let nextNum = itemElements.length - 1;
		if (window.innerWidth > breakpoint) {
			prevNum += 1;
			nextNum -= 1;
		}

		if (currentNum > prevNum) {
			prevElement.classList.remove('disabled');
		} else {
			prevElement.classList.add('disabled');
		}

		if (currentNum < nextNum) {
			nextElement.classList.remove('disabled');
		} else {
			nextElement.classList.add('disabled');
		}


	}


	// -----------------------------------------------------------------------------


	function initFlick() {
		const DX = 50;
		let stX, mvX, mvY;

		slideShowInnerElement.addEventListener('touchstart', (e) => {
			stX = e.touches[0].pageX;
			// eslint-disable-next-line no-multi-assign
			mvX = mvY = null;
		});
		slideShowInnerElement.addEventListener('touchmove', (e) => {
			mvX = e.changedTouches[0].pageX;
			mvY = e.changedTouches[0].pageY;
		});
		slideShowInnerElement.addEventListener('touchend', (e) => {
			if (mvX === null || mvY === null) return;
			if (mvX < stX - DX) {  // <-
				nextElement.click();
				e.preventDefault();
			} else if (stX + DX < mvX) {  // ->
				prevElement.click();
				e.preventDefault();
			}
		});
	}

}());
